import { API_BASE_URL } from '@/config/api';

export const MIN_BESTSELLERS = 6;
export const MAX_BESTSELLERS = 12;

export const fetchBestsellerIds = async (): Promise<string[]> => {
  const response = await fetch(`${API_BASE_URL}/read/v1/service/bestsellers`);
  if (!response.ok) throw new Error('Unable to load Bestsellers');
  const data = await response.json();
  return Array.isArray(data.productIds) ? data.productIds.filter((id: unknown): id is string => typeof id === 'string') : [];
};

export const saveBestsellerIds = async (productIds: string[], token: string): Promise<string[]> => {
  const response = await fetch(`${API_BASE_URL}/api/admin/bestsellers`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', token },
    body: JSON.stringify({ productIds }),
  });
  if (!response.ok) {
    const data = await response.json().catch(() => null);
    throw new Error(data?.error || 'Unable to save Bestsellers');
  }
  const data = await response.json();
  return Array.isArray(data.productIds) ? data.productIds : productIds;
};
